/** OPS-02: the build's commit sha; the Dockerfiles replace the placeholder (APP_RELEASE build argument). */
const BUILD_RELEASE = 'e72cd378514fb21f478d5c629745b07fa528aaf6';

export const APP_RELEASE = BUILD_RELEASE.startsWith('__') ? 'local' : BUILD_RELEASE;
